import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-manager-menu',
  templateUrl: './manager-menu.component.html',
})
export class ManagerMenuComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
